import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "text-2xl font-medium text-left" }
const _hoisted_3 = { key: 1 }
const _hoisted_4 = { class: "text-left text-xl mb-[3%] font-normal" }



    
export default /*@__PURE__*/_defineComponent({
  __name: 'OrganizationAndContactName',
  props: {
        organizationName: String,
        contactName: String,
        contactId: [String, Number],
    },
  setup(__props) {

    const props = __props

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (__props.organizationName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("h2", _hoisted_2, _toDisplayString(__props.organizationName), 1)
        ]))
      : _createCommentVNode("", true),
    (__props.contactName)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("h2", _hoisted_4, _toDisplayString(__props.contactName) + " (" + _toDisplayString(__props.contactId) + ") ", 1)
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})